import {
  hasCaseManagerGroup,
  hasPartnerGroup,
  hasSchedulerGroup,
  hasTechGroup,
} from 'khshared/cognitoUtils';
import React from 'react';
import { Platform } from 'react-native';
import { Redirect } from 'react-router';

import KHAuth from '../utils/KHAuth';

export default function HomeScreen(): JSX.Element {
  if (!KHAuth.isSignedIn()) {
    // On Android app, we want to redirect to signin page instead of booking redirect.
    if (Platform.OS === 'android') return <Redirect to="/android-permissions-screen" />;
    if (Platform.OS === 'ios') return <Redirect to="/ios-permissions-screen" />;
    return <Redirect to="/booking/booking-redirect" />;
  }

  const groups = KHAuth.getGroupsOrThrow();
  if (hasCaseManagerGroup(groups)) {
    return <Redirect to="/case-manager/referral-booking/verification" />;
  }

  if (hasPartnerGroup(groups)) {
    return <Redirect to="/partner/appointments" />;
  }

  if (hasTechGroup(groups)) {
    return <Redirect to="/tech/appointments" />;
  }

  if (hasSchedulerGroup(groups)) {
    return <Redirect to="/scheduler/appointments/allAppointments" />;
  }

  // coordinators redirect to the booking flow
  return <Redirect to="/booking/booking-redirect" />;
}
